import ThemeToggle from './ThemeToggle';

function Footer() {
  return (
    <footer>
      <div className="footer-left"><span>CROUSENTILLD</span></div>
      <ThemeToggle />
      <div className="footer-right"><span>TORQUE – Drive Your Day!</span></div>
    </footer>
  );
}

export default Footer;